import { useUserProfile } from '_clean-code/api/hooks/useUserProfile';

export const useUserRole = () => {
  const { userData } = useUserProfile();

  return {
    isAdmin: userData?.role !== 'user',
    isSuperAdmin:
      userData?.role === 'superuser' || userData?.role === 'superadmin'
  };
};
